import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormUtilsService {
  constructor() {}

  /**
   * Affiche la partie d'un formulaire correspondant à la sélection utilisateur d'un radio button divisible Oui/Non
   */
  public isDivisible(
    form: FormGroup,
    uid: string,
    attribute: string,
    flexCheck: Map<number, boolean>,
    index: number
  ): boolean {
    const controlName = uid + '_SepAtt_' + attribute;
    const KEY_OUI = 'Oui';

    let isDivisible = true;

    if (form.controls[controlName]) {
      flexCheck.set(index, form.controls[controlName].value === KEY_OUI);

      isDivisible =
        form.controls[controlName].value === attribute ||
        form.controls[controlName].value === KEY_OUI;
    }
    return isDivisible;
  }

  /**
   * Permet d'afficher/cacher un champ ainsi que d'avoir la bonne option sélectionnée
   * @param control Le formcontrol concerné par le groupe de radio buttons
   */
  isHiddenOrChecked(control: AbstractControl): boolean {
    let value = true;

    if (control) {
      // Vide = Bouton "Non"
      if (control.value === '') {
        value = true;
      } else {
        // Sur un mat-radio-button, la value ne doit pas être settée pour pouvoir être gérée à null (Bouton "Oui"), on la set donc côté typescript
        control.setValue(null);
        value = false;
      }
    }
    return value;
  }

  /**
   * Permet de tester la valeur d'un input radio ou checkbox pour afficher/cacher des éléments d'un formulaire
   * @param control Formcontrol de la checkbox
   * @param valueToTest 1ère valeur possible
   * @param elseValue 2e valeur possible
   * @returns valueToTest si expression testée = true sinon elseValue, elseValue par défaut
   */
  isInputChecked(control: AbstractControl, valueToTest: any, elseValue: any) {
    if (control) {
      if (control.value === valueToTest) {
        return valueToTest;
      } else {
        return elseValue;
      }
    }
    return valueToTest;
  }

  /**
   * Affiche la partie d'un formulaire correspondant à la sélection utilisateur d'un radio button divisible Oui/Non
   */
  public isOui(
    form: FormGroup,
    uid: string,
    attribute: string,
    flexCheck: Map<number, boolean>,
    index: number,
    baseValue: boolean
  ): boolean {
    const controlName = uid + '_SepAtt_' + attribute;
    const KEY_OUI = 'Oui';

    let isDivisible = true;

    if (form.controls[controlName]) {
      if (form.controls[controlName].value) {
        flexCheck.set(index, form.controls[controlName].value === KEY_OUI);

        isDivisible =
          form.controls[controlName].value === attribute ||
          form.controls[controlName].value === KEY_OUI;
      } else {
        flexCheck.set(index, baseValue);
        isDivisible = baseValue;
      }
    }
    return isDivisible;
  }
}
